import { DirectiveBase } from '../../angular-directive-base.directive';
import { SchemaFormDatePickerController } from './schema_form_date_picker.controller';

export class SchemaFormDatePicker extends DirectiveBase {

  constructor(private $filter) {
    super();
    this.require = ['ngModel'];
    this.bindToController = true;
    this.controller = SchemaFormDatePickerController;
    this.controllerAs = 'vm';
    this.restrict = 'A';
    this.scope = false;
    this.link = (scope, iElement, iAttrs, ngModelCtrl) => { this.linkFunction(scope, iElement, iAttrs, ngModelCtrl); };
  }

  private linkFunction(scope, iElement, iAttrs, ngModelCtrl) {
    scope.vm.ngModel = ngModelCtrl;
    scope.filter = this.$filter;
  }
}